<template>
  <section class="advantage">
      <div class="advantage__content container">
        <h1 class="advantage__title --fade-in-up" data-vertical-ivp-class="--animate">
          The MHHC Advantage
        </h1>
        <div class="--fade-in-up --delay-1" data-vertical-ivp-class="--animate">
          <p class="advantage__description">
            E-commerce is a $5.5 trillion market, and by making extended warranty protection more available to this
            market, we are positioned to create new opportunities. Our subsidiary ONBLi will be making waves in the space very soon.
            <br><br>
            ONBLi is headed by industry veteran and accomplished e-commerce expert Anderson Salgado. Mr. Salgado was
            instrumental in developing the Pro and Luxury Beauty category while at Amazon (one of the fastest-growing
            categories of the platform since 2016) and he subsequently launched his own agency to help other brands to do the same.
            <br><br>
            "We are excited to have ONBLi leading the charge for MHHC's growth efforts going forward and couldn't have
            picked a more qualified person than Anderson Salgado to lead those efforts," said CEO Frank Hawley.
            <br><br>
            ONBLi members will be able to subscribe to paid memberships that include free shipping and extended warranties
            on all of ONBLi's products, partner brands, and third-party products.
            <br><br>
            "I'm excited for what lies ahead and I look forward to leveraging my experience in e-commerce, especially
            as it relates to men's grooming and premium beauty products," added Salgado.
          </p>
        </div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Advantage',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/advantage.scss";
</style>
